import { c as _c } from "react/compiler-runtime";
import { Spinner, Text, VStack } from '@chakra-ui/react';
import { DialogBody, DialogContent, DialogHeader, DialogRoot, DialogTitle } from '@src/components/chakra-ui/dialog';
import { CLARITY_IMPORT_HOLD_STAGES, HOLD_REVEAL_CAP, type ClarityAdvisorImportHoldPhase, holdActiveIndex } from '@src/components/sco/Advisors/sections/clarityAdvisorImportHold';
import { ProcessingChecklist } from '@src/components/sco/RequestFunnel/PitchDeckAudit/components/ProcessingChecklist';
import { useEffect, useState } from 'react';
export type ClarityAdvisorImportHoldDialogProps = {
  phase: ClarityAdvisorImportHoldPhase;
};
const REVEAL_MS = 1800;

/**
 * Non-closable hold dialog while Clarity claim + extract run.
 * Checklist rows fade in like pitch-deck analyzing / goal-setup loading.
 */
export const ClarityAdvisorImportHoldDialog = t0 => {
  const $ = _c(14);
  const {
    phase
  } = t0;
  const open = phase !== "idle";
  const [revealedIndex, setRevealedIndex] = useState(0);
  let t1;
  let t2;
  if ($[0] !== open) {
    t1 = () => {
      if (!open) {
        setRevealedIndex(0);
        return;
      }
      const interval = window.setInterval(() => {
        setRevealedIndex(_temp);
      }, REVEAL_MS);
      return () => window.clearInterval(interval);
    };
    t2 = [open];
    $[0] = open;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== phase || $[4] !== revealedIndex) {
    t3 = holdActiveIndex(phase, revealedIndex);
    $[3] = phase;
    $[4] = revealedIndex;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const activeIndex = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <DialogHeader padding={0}><VStack align="center" gap={5} textAlign="center" width="full"><Spinner colorPalette="orange" size="xl" /><DialogTitle fontWeight="semibold" textAlign="center" textStyle="lg">Setting up your advisor application…</DialogTitle></VStack></DialogHeader>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Text color="fg.muted" fontFamily="longform" fontSize="sm" textAlign="center">We're importing your Clarity profile and filling empty fields. This usually takes a few seconds.</Text>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = Math.max(0, activeIndex);
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = [...CLARITY_IMPORT_HOLD_STAGES];
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6) {
    t8 = <DialogContent bgColor="colorPalette.container" maxWidth="28em" padding={8} width="full">{t4}<DialogBody paddingBottom={0} paddingTop={6} paddingX={0}><VStack align="stretch" gap={5}>{t5}<ProcessingChecklist activeIndex={t6} stages={t7} /></VStack></DialogBody></DialogContent>;
    $[9] = t6;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== open || $[12] !== t8) {
    t9 = <DialogRoot lazyMount={true} modal={true} closeOnEscape={false} closeOnInteractOutside={false} motionPreset="scale" open={open} placement="center" size="md" onOpenChange={_temp2}>{t8}</DialogRoot>;
    $[11] = open;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  return t9;
};
function _temp(index) {
  return Math.min(index + 1, HOLD_REVEAL_CAP);
}
function _temp2() {}